/* eslint-disable no-unused-vars */

import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import { html } from "@polymer/polymer/lib/utils/html-tag.js";
import template from "./ns-badge.html";

/**
 * The ns-badge should be used for
 *
 * <h1>Badge</h1>
 * <demo-snippet class="demoSnippet">
 *   <template>
 *     <ns-badge></ns-badge>
 *   </template>
 * </demo-snippet>
 *
 */
export class NsBadge extends PolymerElement {
  constructor() {
    super();
  }

  static get is() {
    return "ns-badge";
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get properties() {
    return {
      properties: {
        color: String,
        abbreviation: {
          type: String,
          value: ""
        },
        circle: Boolean,
        oval: Boolean,
        hex: String
      }
    };
  }

  ready() {
    super.ready();
    if (this.hex) {
      this.updateStyles({ "--badge-background-color": this.hex });
    }
  }
}
customElements.define(NsBadge.is, NsBadge);
